<nz-icon [nzType]="type" [style.color]="iconColor"></nz-icon>
